import { Action, AnyAction, combineReducers, configureStore, Reducer, ThunkAction } from "@reduxjs/toolkit";
import menuToggle from "./layouts/NavSlice";
import account from "./slices/Accounts";
import catalogues from "./slices/Catalogues";
import dashboard from "./slices/Dashboard";
import department from "./slices/Departments";
import dispensePricing from "./slices/DispensePricing";
import functions from "./slices/Functions";
import login from "./slices/Login";
import owners from "./slices/Owners";
import permissions from "./slices/Permissions";
import products from "./slices/Products";
import StockGroups from "./slices/StockGroups";
import newStocks from "./slices/Stocks";
import storeGroups from "./slices/StoreGroups";
import storesTable from "./slices/Stores";
import storeStocks from "./slices/StoreStocks";
import subDepartment from "./slices/SubDepartment";
import suppliers from "./slices/Suppliers";
import supplierNameMappings from "./slices/SupplierNameMappings";
import sync from "./slices/Sync";
import Toasts from "./slices/Toasts";
import user from "./slices/User";
import reports from "./slices/Reports";
import global from "./slices/Global";
import bulkEdit from "./slices/BulkEdit";
import importWizard from "./slices/ImportWizard";
import manageGroups from "./slices/ManageGroups";
import preferredBrands from "./slices/PreferredBrands";
import pbsManufacturers from "./slices/PbsManufacturers";
import genericCategories from "./slices/GenericCategories";
import priceGroups from "./slices/PriceGroups";
import assignPriceGroup from "./slices/AssignPriceGroup";
import MultiStore from "./slices/MultiStore";
import managedManufacturers from "./slices/ManagedManufacturers";
import tradingTotalsReportPageSlice from "./slices/tradingTotalsReportPageSlice";
import stockDepartmentPageSlice from "./slices/PageMemory/StocksDepartmentPageSlice";

const combinedReducer = combineReducers({
  account: account,
    assignPriceGroup: assignPriceGroup,
    bulkEdit: bulkEdit,
    catalogues: catalogues,
    dashboard: dashboard,
    department: department,
    dispensePricing: dispensePricing,
    global: global,
    genericCategories: genericCategories,
    importFunctions: functions,
    importWizard: importWizard,
    login: login,
    logedinUser: user,
    manageGroups: manageGroups,
    managedManufacturers: managedManufacturers,
    pbsManufacturers: pbsManufacturers,
    menuToggle: menuToggle,
    owners: owners,
    multiStore: MultiStore,
    permissions: permissions,
    preferredBrands: preferredBrands,
    priceGroups: priceGroups,
    products: products,
    reports: reports,
    storeGroups: storeGroups,
    storeStocks: storeStocks,
    stockGroups: StockGroups,
    stocks: newStocks,
    stores: storesTable,
    subDepartment: subDepartment,
    suppliers: suppliers,
    supplierNameMappings: supplierNameMappings,
    sync: sync,
    toasts: Toasts,
    pageTradingTotalsReport: tradingTotalsReportPageSlice,
    stockDepartmentPageSlice: stockDepartmentPageSlice
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === 'globalSlice/clearStore') { // check for action type 
    state = {} as RootState;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
